// Add your custom JS here!!!

//---------------------------------
// Set top level items to clickable
//---------------------------------

// Products
jQuery(document).ready(function () {
  // Target the parent menu item by class name and add a click event
  jQuery(".lsm-menu-prod").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/products/";
  });
});

// Support
jQuery(document).ready(function () {
  // Target the parent menu item by class name and add a click event
  jQuery(".lsm-menu-sup").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/support/";
  });
});
